import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import {Item} from '../../models/Item';
import {ThreeWordsService} from '../../services/3Words/three-words.service';
import {MeasurementService} from '../../services/measurementAdapter/measurement.service';
import {Subscription} from 'rxjs';
import {isViewMode} from 'src/configs/view_only';
import {CalculateInputsService} from '../../services/calculateInputsService/calculate-inputs.service';
import {
  INPUT_COLOR_SETTINGS_NAME,
  INPUT_OPACITY_SETTINGS_NAME,
  STATIC_FIELD_IN_DATE,
  STATIC_FIELD_OUT_DATE
} from '../../interfaces/constants';
import {GlobalEventsService} from '../../services/global-events.service';
import set = Reflect.set;
import {ObjectConfig} from "@src/app/models/ObjectConfig";
import {ItemManagerService} from '@src/app/services/itemManager/item-manager.service';
import {MapPosition} from "@src/app/models/MapPosition";
import {HttpHeaders, HttpParams} from "@angular/common/http";
import {HttpServiceService} from "@src/app/services/httpService/http-service.service";
declare var Yiit;

@Component({
  selector: 'item-settings',
  templateUrl: './item-settings.component.html',
  styleUrls: ['./item-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemSettingsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() item: Item;

  public Yiit = Yiit;
  private badCalculations = {};

  private inputsCharacterLimit:{[key: string]: number} = {
    __vm_name : 250,
    __vm_vendor_zone: 250,
    __vm_furniture: 1000
  };

  private numberInputs:any[] = ['people_per_car'];
  private zeroForbiddenInputs:string[] = ['fixedHeight', 'fixedWidth'];

  protected cachedPositionsByInput = {};
  private hasMeasurement: boolean;
  private oldInputValues: Map<string, any> = new Map();
  public activeTab = null;
  public isViewMode = isViewMode;
  public colorSettings = {value: null};
  public opacitySettings = {value: null};

  constructor(
    protected _3Words: ThreeWordsService,
    protected measurement: MeasurementService,
    protected cd: ChangeDetectorRef,
    protected calcInputs: CalculateInputsService,
    protected globalEvents: GlobalEventsService,
    protected im: ItemManagerService,
    protected http: HttpServiceService
  ) {

  }

  ngOnInit(): void {
    this.cacheItemsW3wPositions();
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this.subscribes.unsubscribe();
    this.cd.detach();
  }

  public getOriginalInputValue(input): string {
    return input.originalLabel + ': ' + input.originalValue;
  }

  public setActiveTab(htmlElement){
    this.activeTab = (htmlElement === this.activeTab) ? null : htmlElement;
  }

  isActiveTab(htmlElement){
    return this.activeTab === htmlElement;
  }

  public getItemSettings () {
    var settings = {};
    for (var name in this.item.config.getInputs()) {
      if (!this.item.config.getInputs().hasOwnProperty(name)) { continue; }
      var options = this.item.config.getInputs()[name];
      if (name == '__baby_number') { continue; }
      if (name == '__figure_zoom') { continue; }
      if (name == 'fixed-size-disabled') { continue; }
      if (name == 'measurement') { continue; }
      if (name == INPUT_COLOR_SETTINGS_NAME) { continue; }
      if (name == INPUT_OPACITY_SETTINGS_NAME) { continue; }
      if (!(window.hasOwnProperty('CAN_CHANGE_OBJECT_ICON') && window['CAN_CHANGE_OBJECT_ICON'])) {
        if (name == 'customIcon') { continue; }
      }
      if (options.hidden) { continue; }
      if (options.hasOwnProperty('per_vertex') && options.per_vertex) { continue; }
      // if (options.hasOwnProperty('calculation')) { continue; }
      settings[name] = options;
    }
    if (window.hasOwnProperty('CAN_CHANGE_OBJECT_ICON') && window['CAN_CHANGE_OBJECT_ICON'] && this.item.config.getObjectConfig().getToolType() == ObjectConfig.TYPE_FIXED_FIGURE) {
      if (!settings.hasOwnProperty('customIcon')) {
        settings['customIcon'] = {
          type:'image',
          label: 'Icon',
          value: null,
          getValue: function () { return this.value; },
          getNumericValue: function () {return parseFloat(this.value)}
        }
      }
    }
    return settings;
  };

  isContainVertexOption(){
    for (let name in this.item.config.getInputs()) {
      let options = this.item.config.getInputs()[name];
      if (options.hasOwnProperty('per_vertex')){
        return true;
      }
    }
    return false;
  }

  public hasItemSettings() {
    return (Object.keys(this.getItemSettings()).length > 0);
  };

  getItemInfo() {
    var info = {};
    for (var name in this.item.config.getInputs()) {
      if (!this.item.config.getInputs().hasOwnProperty(name)) { continue; }
      var options = this.item.config.getInputByName(name);
      if (name == '__baby_number') { continue; }
      if (name == '__figure_zoom') { continue; }
      if (name == 'fixed-size-disabled') { continue; }
      if (options.hidden) { continue; }
      if (!options.hasOwnProperty('calculation')) { continue; }
      info[name] = options;
    }
    return info;
  };

  getSummaryCalculationValue (name, item, calculation) {
    return this.calcInputs.getSummaryCalculationValue(name, item, calculation);
  };


  public getMeasurementCalc(item, name, calculation): any {
    return this.calcInputs.getMeasurementCalc(item, name, calculation);
  }

  copyCalculationValue($event, val, item) {
    $event.preventDefault();
    // @ts-ignore
    if (navigator.clipboard) {
      // @ts-ignore
      navigator.clipboard.writeText(val).then(() => {
        this.globalEvents.ToastNotificationEvent.emit({
          message: 'Coordinates copied to clipboard',
          autoHideDelay: 1500,
          title: 'Coordinates copied',
          classes: ['notification']
        });
      });
    } else {
      this.globalEvents.ToastNotificationEvent.emit({
        message: 'Position copy error',
        autoHideDelay: 1500,
        title: 'Your browser does not support copying',
        classes: ['error']
      });
    }
    const csrfFrontend = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement).content;
    this.http.sendPostRequest('/event/log-event-analytics/'+window['EVENT_ID'],
      new HttpParams()
        .set('_csrf-frontend', csrfFrontend.toString())
        .set('event_name', 'w3w_copy')
        .set('data', '{"object_id": "' + item.getId() + '"}')
        .toString(),
      new HttpHeaders({
        'Content-Type':  'application/x-www-form-urlencoded'
      })
    ).subscribe();
  }

  setInputVal(item, key, event){
    let result = event.target.value;
  }

  calculateObjectParam(item, calculation, name) {
    return this.calcInputs.calculateObjectParam(item, calculation, name);
  }

  canEditItem(item): boolean {
    return true;
  }

private getParamOptions (optionConfig) {
  // if (optionConfig.options == '{PHONE_USERS}') {
  //   return PHONE_USER_OPTIONS;
  // }
  return optionConfig.options;
};

private getParamOptionValue = function (option) {
  if (typeof option == 'string') {
    return option;
  }
  if (option.hasOwnProperty('value')) {
    return option.value;
  }
  return option.label;
};

  private getParamOptionStyle = function (option) {
    return ((typeof option == 'string') ? '' : option.style);
  };

  private getParamOptionLabel = function (option) {
    return ((typeof option == 'string') ? option : option.label);
  };



  removeSupplierInput(item){
    item.getSubject(Item.SUBJECT_INPUTS_CHANGED).next('removeSupplier');
  }
  removeTimelineInput(item){
    item.getSubject(Item.SUBJECT_INPUTS_CHANGED).next('removeTimeline');
  }

  removeVendorsInput(item){
    item.getSubject(Item.SUBJECT_INPUTS_CHANGED).next('removeVendors');
  }

  removeUeInput(item){
    item.getSubject(Item.SUBJECT_INPUTS_CHANGED).next('removeUe');
  }

  removeCostInput(item){
    item.getSubject(Item.SUBJECT_INPUTS_CHANGED).next('removeCost');
  }

  removeInOutDatesInput(item) {
    item.getSubject(Item.SUBJECT_INPUTS_CHANGED).next('removeInOutDates');
  }

  getInputProp(name, keyVal, setting = null) {
    if (keyVal === 'value' && this.measurement.hasMeasurement(this.item, name) && this.item.config.getInputByName(name)) {
      let result = this.measurement.getMeasurementVal(this.item, this.item.config.getInputByName(name), name);
      if (result == null || result === 0) {
        return '0';
      } else {
        const isHasRightMeasurementLable = (setting) ? this.isSettingHasMeasurement(setting) : false;
        if (isHasRightMeasurementLable) {
          const settingLabel = this.getSettingLabelMeasurement(setting);
          result = result.replace(settingLabel, '').trim();
        }
        return result;
      }
    }

    return this.item.config.getInputProp(name, keyVal);
  }

  getSettingLabel(setting) {
    if (this.hasMeasurement && setting.value.hasOwnProperty('label') && this.item.config.getInputByName(setting.key)) {
      return this.measurement.getMeasurementLabel(this.item, this.item.config.getInputByName(setting.key));
    }
    return this.item.config.getInputProp(setting.key, 'label');
  }

  isSettingHasMeasurement(setting): boolean {
    return this.hasMeasurement && setting.value.hasOwnProperty('label');
  }

  getSettingLabelMeasurement(setting){
    if (this.hasMeasurement && setting.value.hasOwnProperty('label') && this.item.config.getInputByName(setting.key)) {
      return this.measurement.getMeasurementLabelSymbol(this.item, this.item.config.getInputByName(setting.key));
    }
    return null;
  }

  private calculateAllInputs(item){
    this.calcInputs.calculateItemInputs(item);
  }

  private setWrongNumberToZero(value){
    let result:any = parseFloat(value);
    if (result < 0 || isNaN(result)){
      result = '0';
    }
    return result;
  }


  validateItemParam(item: Item, name, prop, event): void {
    const prevValue = item.config.getInputProp(name, prop);
    // character limit
    if (this.inputsCharacterLimit.hasOwnProperty(name)) {
      const count = event.target.value.length;
      if (count > this.inputsCharacterLimit[name]) {
        event.target.value = event.target.value.substring(0, this.inputsCharacterLimit[name]);
      }
    }

    let result = (typeof event === 'string') ? event : event.target.value;
    let NaN = (item.config.getInputProp(name, 'isNaN'));
    if (name.indexOf('point_height') === 0) {
      NaN = true;
    }

    // check for number and negative number
    if (!NaN && !isNaN(parseFloat(result)) && (parseFloat(result).toString()) === result.trim()) {
      result = parseFloat(result);
      if (result < 0) {
        result = 0;
      }
    }

    if (this.numberInputs.includes(name)) {
      result = this.setWrongNumberToZero(result);
      event.target.value = result;
    }

    if (this.zeroForbiddenInputs.includes(name) && result == 0){
      event.target.value = prevValue.toString();
      this.cd.detectChanges();
      return;
    }


    if (this.measurement.hasMeasurement(item, name) && prop.toLowerCase() === 'value') {
      if (result.toString().indexOf(',') >= 0) {
        result = result.replace(/,/, '.');
      }

      if (item.config.getInputByName(name)) {
        result = this.measurement.getUnconvertedInputVal(item, item.config.getInputByName(name), result);
      }

      if (isNaN(result) || result === '') {
        result = '0';
        event.target.value = result;
      }
    }

    if ([STATIC_FIELD_OUT_DATE, STATIC_FIELD_IN_DATE].includes(name)) {
      const {value, error, message} = this.validateInOutDates(item, name, event.target.value);
      result = value;
      if (error) {
        this.globalEvents.ToastNotificationEvent.emit({
          message,
          title: 'In/Out date error',
          classes: ['error']
        });
        event.target.value = value;
        this.cd.detectChanges();
      }
    }

    let _itemToUpdate = this.item.config.isCopy ? this.im.getItemById(item.config.getCopyParentId) : item;

    _itemToUpdate.config.setInputValue(name, prop, result);
    this.calculateAllInputs(_itemToUpdate);

    this.cd.detectChanges();
  }

  // note: is it meaningful to create service/validators as separate classes?
  protected validateInOutDates(item: Item, name: string, newValue: string): { value: string, error: boolean, message: string } {

    const getValue = (inputName: string) => item.config.getInputs()[inputName] ? item.config.getInputs()[inputName].date : null;
    let inValue = getValue(STATIC_FIELD_IN_DATE);
    let outValue = getValue(STATIC_FIELD_OUT_DATE);
    const inTitle = item.config.getInputs()[STATIC_FIELD_IN_DATE].label;
    const outTitle = item.config.getInputs()[STATIC_FIELD_OUT_DATE].label;

    if (name === STATIC_FIELD_OUT_DATE && inValue) {
      const newOutVal = new Date(newValue).getTime();
      inValue = new Date(inValue).getTime();
      if (newOutVal < inValue) {
        return {
          value: outValue,
          error: true,
          message: `${outTitle} cannot be before ${inTitle}`
        };
      }
    }

    if (name === STATIC_FIELD_IN_DATE && outValue) {
      const newInVal = new Date(newValue).getTime();
      outValue = new Date(outValue).getTime();
      if (newInVal > outValue) {
        return {
          value: inValue,
          error: true,
          message: `${inTitle} cannot be after ${outTitle}`};
      }
    }

    return {value: newValue, error: false, message: null};
  }

  protected cacheItemsW3wPositions() {
    let inputs = this.item.config.getInputs();
    let position = this.item.config.getObjectConfig().getPosition();
    for (let p in inputs){
      if (inputs[p].hasOwnProperty('calculation')){
        if (inputs[p].calculation.indexOf("_3words")) {
          if (
            inputs[p].hasOwnProperty('value')
            && (typeof(inputs[p].value) == 'string')
            && inputs[p].value.match(/^\w+\.\w+\.\w+$/)
          ) {
            if (position) {
              this._3Words.cacheSet(
                position.lat,
                position.lng,
                inputs[p].value
              );
              this.cachedPositionsByInput[p] = position;
            }
          }
        }
      }
    }
  }

  timeOptions() {
    let r = [];
    for (let i = 1; i <= 24; i++) {
      r.push(i + ':00');
    }
    return r;
  }

  protected subscribes: Subscription = new Subscription();

  ngOnChanges(changes: SimpleChanges): void {
    this.subscribes.unsubscribe();
    this.subscribes = new Subscription();

    this.cacheItemsW3wPositions();
    this.hasMeasurement = this.measurement.hasMeasurement(this.item);
    this.cd.detectChanges();
    for (let i in this.item.config.getInputs()){
      let input = this.item.config.getInputs()[i];
      if (input.hasOwnProperty('value') && input.value){
        this.oldInputValues.set(i, input.value);
      }
    }

    this.subscribes.add(this.item.config.subject.subscribe(()=>{
      this.cd.detectChanges();
    }));

    this.subscribes.add(this.item.config.serverUpdate.subscribe(()=>{
      this.cd.detectChanges();
    }));

    this.subscribes.add(this.item.getSubject(Item.SUBJECT_INPUTS_CHANGED).subscribe(()=>{
      this.cd.detectChanges();
    }));

    this.subscribes.add(this.measurement.onMeasurementItemListUpdated$.subscribe(()=>{
      this.cd.detectChanges();
    }));

    this.cd.detectChanges();
  }


}
